import {inject, Injectable, LOCALE_ID, NgModule, provideAppInitializer} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {CommonModule, DatePipe, registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';
import {AppRoutingModule} from './app-routing.module';
import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from "@angular/router";
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration} from "@angular/common/http";
import {PagesModule} from "./pages/pages.module";
import {CoreModule} from './@core/core.module';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ToastrModule} from 'ngx-toastr';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgbDatepickerModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmComponent} from "./shared/confirm/confirm.component";
import {ErrorHandlerModule} from "./@core/errors/error-handler.module";
import {NgxSpinnerModule} from "ngx-spinner";
import {NgxImageCompressService} from "ngx-image-compress";
import {AuthModule} from "./@core/authentication/auth.module";
import {InformationModule} from "./information/information.module";
import {NavbarResponsiveComponent} from './shared/navbar-responsive/navbar-responsive.component';
import {FooterCustomComponent} from './shared/footer-custom/footer-custom.component';
import {ConfigService} from "./@core/config/services/config.service";
import {CountdownComponent} from "./shared/countdown/countdown/countdown.component";
import {firstValueFrom} from "rxjs";

registerLocaleData(localeDe);

@Injectable()
export class MyStrategy extends RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  // TODO: ' unexpected empty method 'store' ' > Sonar doesn't like this
  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle|null {
    return null;
  }
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return false;
  }
}

export function initFeatureConfig(configService: ConfigService) {
  return () => configService.getFeatureConfig();
}

export function initCustomerConfig(configService: ConfigService) {
  return () => configService.getCustomerConfig();
}

export function initLogo(configService: ConfigService) {
  return () => configService.getLogoSrc();
}

export function translateServiceInit(translate: TranslateService ) {
  return () => {
    return firstValueFrom(translate.get('de'));
  };
}


@NgModule({ declarations: [
        AppComponent,
        ConfirmComponent,
        NavbarResponsiveComponent,
        FooterCustomComponent,
        CountdownComponent
    ],
    exports: [],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        CoreModule.forRoot(),
        AppRoutingModule,
        PagesModule,
        InformationModule,
        FontAwesomeModule,
        NgbDatepickerModule,
        ToastrModule.forRoot(),
        TranslateModule.forRoot({
            fallbackLang: 'de',
            loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix:".json"}),
        }),
        NgbModule,
        ErrorHandlerModule,
        NgxSpinnerModule,
        AuthModule,
        CommonModule], providers: [
        DatePipe,
        { provide: LOCALE_ID, useValue: 'de-DE' },
        { provide: RouteReuseStrategy, useClass: MyStrategy },
        { provide: NgxImageCompressService },
        provideAnimationsAsync(),
        provideAppInitializer(() => {
        const initializerFn = (initFeatureConfig)(inject(ConfigService));
        return initializerFn();
      }),
        provideAppInitializer(() => {
        const initializerFn = (initCustomerConfig)(inject(ConfigService));
        return initializerFn();
      }),
        provideAppInitializer(() => {
        const initializerFn = (initLogo)(inject(ConfigService));
        return initializerFn();
      }),
        provideAppInitializer(() => {
        const initializerFn = (translateServiceInit)(inject(TranslateService));
        return initializerFn();
      }),
        provideHttpClient(
          withInterceptorsFromDi(),
          withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' })
        ),
    ] })
export class AppModule { }
